  document.addEventListener('DOMContentLoaded', function() {
    const carouselContainers = document.querySelectorAll('.multi-categories-carousel');

    // const concatProductTitles = () => {
    //   document.querySelectorAll('.multi-categories__single-grid__content').forEach(x => {
    //     if(x.firstElementChild.innerText.length > 27){
    //       x.firstElementChild.innerText = `${x.firstElementChild.innerText.substr(0,28)}...`  
    //     }
    // });
    // };

    // concatProductTitles();
    
    carouselContainers.forEach(container => {
      const wrapper = container.querySelector('.multi-categories-carousel-wrapper');
      const slides = container.querySelectorAll('.multi-categories-carousel-slide');
      const prevButton = container.querySelector('.multi-categories-carousel-prev');
      const nextButton = container.querySelector('.multi-categories-carousel-next');
      const controls = container.querySelector('.multi-categories-carousel-controls');

      let currentIndex = 0;

      // Hide controls if there are less than 4 images
      if (slides.length < 4) {
        controls.style.display = 'none';
      }

      function showSlide(index) {
        // Calculate translate percentage based on 3.5 images
        const translatePercentage = -((index * 100) / 4);
        wrapper.style.transform = `translateX(${translatePercentage}%)`;
      }

      function updateButtons() {
        prevButton.disabled = currentIndex === 0;
        // Adjust next button condition for 4 images
        nextButton.disabled = currentIndex >= slides.length - 4;
      }

      showSlide(currentIndex);
      updateButtons();

      nextButton.addEventListener('click', () => {
        currentIndex = Math.min(currentIndex + 1, slides.length - 4);
        showSlide(currentIndex);
        updateButtons();
      });

      prevButton.addEventListener('click', () => {
        currentIndex = Math.max(currentIndex - 1, 0);
        showSlide(currentIndex);
        updateButtons();
      });
    });
  });

  var activeCollection = "";
  const handleCurrentCollection = (event, index) => {
    const counter = index - 1;
    const container = document.querySelectorAll(".collection-list__wrapper")[0];
    const gridRows = document.querySelectorAll(".multi-categories__row-2");
    console.log("container", container);
    console.log("gridRows", gridRows);

    for (let child of container.childNodes) {
      if (child.classList.contains("active-collection")) {
        child.classList.remove("active-collection");
      }
    }

    for (let child of gridRows) {
      if (child.classList.contains("hidden") === false) {
        child.classList.add("hidden");
      }
    }
    container.childNodes[counter].classList.add("active-collection");
    gridRows[counter].classList.remove("hidden");

    activeCollection = container.childNodes[counter].textContent;
  };